import { formatDate } from "@/src/components/common/common.js";
export default class AddPatientFormHandler {
    static populatedFormData(data, userInfo, SALUTE, GENDER) {
        if (!data) return {};

        const formattedDate = data?.dob
            ? formatDate(data?.dob, "YYYY/MM/DD")
            : null;
        return {
            name: data?.pName || "",
            email: data?.email || "",
            salutation: SALUTE?.find((s) => s.value === data?.title) || {
                label: "Mr",
                value: "Mr",
            },
            gender: GENDER?.find((g) => g.value === data?.gender) || {
                label: "Male",
                value: "M",
            },
            phone: data?.mobile || userInfo?.mobileNo,
            dob: data?.dob ? formattedDate : null,
            pincode: data?.pincode?.toString() || "",
            adress: data?.houseNo || "",
        };
    }

    static getSubmittedValues(data, params, userInfo, isFirstUser = {}) {
        if (!data) return {};

        const formattedDate = data?.dob
            ? formatDate(data?.dob, "YYYY-MM-DD")
            : null;
        const baseData = {
            title: data?.salutation?.value,
            houseNo: data?.adress,
            pincode: data?.pincode,
            mobile: userInfo?.mobileNo ?? data?.phone,
            email: data?.email,
            dob: formattedDate,
            gender: data?.gender?.value,
            pName: data?.name,
        };

        // If this is the first user (i.e., sign-up scenario)
        if (isFirstUser && Object.keys(isFirstUser).length > 0) {
            return {
                userDetails: { ...baseData },
                requestGuid: isFirstUser?.requestId,
                location: isFirstUser?.location,
            };
        }

        // If editing existing user
        if (params) {
            return { ...baseData, uid: params };
        }

        // Creating a new patient
        return baseData;
    }
}
